import React, { useState, useContext } from "react";
import axios from "axios";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import {
  CustomSelect,
  TextInput,
} from "components/Input/Index.js";
import { batiment } from "variables/patrimoine.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { getSite } from "services/ConfigServices";
import {  NotificationManager } from 'react-notifications';

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      backgroundColor: '#fff',
      //width: "30ch",
    },
  },
  formControl: {
    margin: '8px',
    minWidth: 120,
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

function EditEquipmentDialog(props) {

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const {
    energy,
    parameters,
    closeModal,
    refetch,
    idSelected,
    prevEquipList,
    name,
    clef,
    type,
    loaded,
    handleNameChange,
    handleClefChange,
    handleTypeChange,
  } = props;

  const handleSubmit = async (event) => {
    const indexToReplace = prevEquipList.findIndex(
      (x) => x.uuid === idSelected
    );

    const editedEquipment = {
      name,
      clef,
      type,
      'uuid':idSelected,
    };

    const equiplist = prevEquipList;
    equiplist.splice(indexToReplace, 1, editedEquipment);

    axios
      .put(
        getSite(chartIdGroup,"renewables.equipmentlist"),
        equiplist,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Equipement modifié");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
        closeModal();
        refetch();
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const typeData = [
    { name: "PV", id: "pv" },
    { name: "Solaire thermique", id: "solar" },
    { name: "Eolien", id: "wind" },
    { name: "Biomasse", id: "biomass" },
    { name: "Géothermie", id: "geothermal" },
  ];

  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
          <div>
              <TextInput
                inputTitle={batiment.renewables.equipmentlist.key}
                textInput={clef}
                handleTextInputChange={handleClefChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={batiment.renewables.equipmentlist.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={batiment.renewables.equipmentlist.type}
                selectValue={type}
                handleSelectValueChange={handleTypeChange}
                data={typeData}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <Button
              noWrap
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "0px",
                marginBottom: "0px",
                marginTop: "15px",
                fontFamily: '"Source Sans Pro",sans-serif',
                width: "96%",
                marginLeft: "2%",
              }}
              onClick={() => {
                handleSubmit();
              }}
            >
              Enregistrer
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </div>
  );
}

export default EditEquipmentDialog;
